import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, finalize, of, tap } from 'rxjs';
import { AuthService } from '../../_core/auth.service';
import { BrandingService } from '../../_core/branding.service';
import { Spinner } from '../../_core/spinner';
import { ILoginData, IResponse, LoginFlowDestination } from '../../core.interface';

@Component({
  selector: 'app-autologin',
  styles: [':host img { max-width: 250px; }'],
  template: `
    <div class="d-flex align-items-center justify-content-center w-100 vh-100 p-4">
      @if ($branding.logoUrl(); as logo) {
        <img class="dropShadow" [src]="logo" alt="logo" />
      }
    </div>
  `,
})
export class AutologinComponent implements OnInit {
  private router = inject(Router);
  private aRoute = inject(ActivatedRoute);
  private $auth = inject(AuthService);
  private $spinner = inject(Spinner);
  public $branding = inject(BrandingService);

  ngOnInit(): void {
    this.$spinner.show();
    this.aRoute.queryParams.subscribe((params) => {
      const code = params['code'];
      if (!code) {
        this.navigateToLogin('Código SSO no válido');
        return;
      }
      this.exchangeCode(code);
    });
  }

  private exchangeCode(code: string): void {
    this.$auth
      .ssoExchange(code)
      .pipe(
        tap(async (response) => {
          if (!response) {
            this.navigateToLogin('Error de autenticación');
            return;
          }
          const destination = await this.$auth.completeLoginFlow();
          this.navigateAfterLogin(destination);
        }),
        catchError((err: { error?: { message?: string } }) => {
          this.$auth.clearSession();
          this.navigateToLogin(err.error?.message ?? 'Error de autenticación');
          return of(null);
        }),
        finalize(() => this.$spinner.hide()),
      )
      .subscribe();
  }

  private navigateAfterLogin(destination: LoginFlowDestination): void {
    switch (destination) {
      case 'CHANGE_PASSWORD':
        this.router.navigate(['/', 'change-password'], {
          replaceUrl: true,
        });
        break;
      case 'LOADING':
        this.router.navigate(['/', 'loading'], { replaceUrl: true });
        break;
      case 'PROPIEDADES':
        this.router.navigate(['/', 'propiedades'], { replaceUrl: true });
        break;
    }
  }

  private navigateToLogin(error: string): void {
    this.$spinner.hide();
    this.router.navigate(['/', 'login'], {
      queryParams: { error },
      replaceUrl: true,
    });
  }
}
